import { useQuery } from "react-query";
import qs from "qs";
import URL from "core/resources/urls";
import http from "infra/http";
import { useFilters } from "core/features/filters/store";
import { RdoOperacoesResponse } from "../partials/diario/rdoOperacoes.types";
import {
  resolveRdoDataRange,
  RdoDataModo,
} from "../partials/diario/rdoDateRange";

type Params = {
  enabled?: boolean;
};

export function useGetRdoOperacoes({ enabled = true }: Params = {}) {
  const unidadeId = useFilters((s) => s.filters.unidade?.id);
  const safraId = useFilters((s) => s.filters.safra?.id);
  const safraPeriodoIds = useFilters(
    (s) => s.filters.filtersAdvanced?.safraPeriodoIds || []
  );
  const rdoDataModo = useFilters(
    (s) => (s.filters.filtersAdvanced?.rdoDataModo || "geral") as RdoDataModo
  );
  const rdoDataInicio = useFilters(
    (s) => s.filters.filtersAdvanced?.rdoDataInicio
  );
  const rdoDataFim = useFilters((s) => s.filters.filtersAdvanced?.rdoDataFim);

  const canFetch =
    enabled && !!unidadeId && !!safraId && safraPeriodoIds.length > 0;

  const dateRange = resolveRdoDataRange(rdoDataModo, rdoDataInicio, rdoDataFim);

  return useQuery(
    [
      URL.RELATORIO.DIARIO_OPERACOES,
      unidadeId,
      safraId,
      safraPeriodoIds,
      rdoDataModo,
      rdoDataInicio,
      rdoDataFim,
    ],
    async (): Promise<RdoOperacoesResponse> => {
      const { data } = await http.get<RdoOperacoesResponse>(
        URL.RELATORIO.DIARIO_OPERACOES,
        {
          params: {
            UnidadeId: unidadeId,
            SafraId: safraId,
            SafraPeriodoIds: safraPeriodoIds,
            ...dateRange,
          },
          paramsSerializer: (params) =>
            qs.stringify(params, { indices: false }),
          headers: {
            "api-version": "1.0",
          },
        }
      );

      return data ?? [];
    },
    {
      enabled: canFetch,
      keepPreviousData: true,
    }
  );
}
